import type { ModelDocument } from "~/types/docs/model-document";

// Upstream ids can contain "/" or ":" (e.g. "qwen/qwen3.5-35b", "gemma3:12b"), which are not URL-segment safe.
export const getModelSlug = (id: string) =>
  id
    .toLowerCase()
    .replace(/[^a-z0-9.-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

export const getModelPath = (model: Pick<ModelDocument, "id">) => `/models/${getModelSlug(model.id)}`;

export const getModelNameFa = (model: ModelDocument) => model.metadata?.nameFa?.trim() || model.name;

export const getModelNameEn = (model: ModelDocument) => model.metadata?.nameEn?.trim() || model.name;

export const formatCreditsPerToken = (creditsPerMillion: number) =>
  (Number(creditsPerMillion.toFixed()) / 1_000_000).toLocaleString();
